/* import __COLOCATED_TEMPLATE__ from './updated-by.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import { type LocalizedKnowledgeContent } from 'embercom/objects/knowledge-hub/localized-knowledge-content';

interface Args {
  activeContent: LocalizedKnowledgeContent;
}

const UpdatedBy = templateOnlyComponent<Args>();
export default UpdatedBy;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::Shared::DataSection::UpdatedBy': typeof UpdatedBy;
    'knowledge-hub/content-editor/shared/data-section/updated-by': typeof UpdatedBy;
  }
}
